export default __webpack_public_path__ + "static/media/felipe_1.9fd03be7.wav";